var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0123 13.4769C9.0123 14.0139 9.3533 14.1609 9.7723 13.8079L15.6843 8.64694C15.8829 8.49315 15.9991 8.25611 15.9991 8.00494C15.9991 7.75377 15.8829 7.51673 15.6843 7.36294L9.7723 2.19294C9.3523 1.83794 9.0123 1.98694 9.0123 2.52394V5.99894H8.0123C4.1923 5.99894 0.925304 9.16494 0.129304 12.5849C0.0703156 12.8388 0.0285538 13.0964 0.00430409 13.3559C-0.0256959 13.6229 0.104304 13.6819 0.295304 13.4939C0.295304 13.4939 0.349304 13.4459 0.395304 13.3939C2.41755 11.3436 5.13765 10.1297 8.0143 9.99394H9.0143L9.0123 13.4769Z"
  })));
};
export default SvgShare;